'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _btoa = require('btoa');

var _btoa2 = _interopRequireDefault(_btoa);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MeetingInfoUtil = {};

/**
 * Helper function to check if a string matches a known meeting link pattern
 * @param {String} value  string to parse and see if it matches a meeting link
 * @returns {Boolean}
 */
MeetingInfoUtil.isMeetingLink = function (value) {
  // eslint-disable-next-line no-warning-comments
  // TODO: lets remove regex from this equation and user URI matchers and such
  var regex = /(.*).webex.com\/(?:meet|m)\/(.*)/;
  var m = regex.exec(value);
  if (m !== null && m.length === 3) {
    return true;
  }
  return false;
};

MeetingInfoUtil.isSipUri = function (sipString) {
  // TODO: lets remove regex from this equation and user URI matchers and such
  var sipUri = _constants.DIALER_REGEX.SIP_ADDRESS.exec(sipString);
  return sipUri;
};

MeetingInfoUtil.isPhoneNumber = function (phoneNumber) {
  var isValidNumber = _constants.DIALER_REGEX.PHONE_NUMBER.test(phoneNumber);
  return isValidNumber;
};

MeetingInfoUtil.generateOptions = function (from) {
  var destination = from.destination,
      type = from.type,
      conversationServiceUrl = from.conversationServiceUrl;

  if (type) {
    return {
      destination: destination,
      type: type
    };
  }
  var options = {};
  // TODO: convert to sip URI?
  if (MeetingInfoUtil.isMeetingLink(destination)) {
    options.type = _constants.MEETING_LINK;
    options.destination = destination;
  } else if (MeetingInfoUtil.isSipUri(destination)) {
    options.type = _constants.SIP_URI;
    options.destination = destination;
  } else if (MeetingInfoUtil.isPhoneNumber(destination)) {
    options.type = _constants.SIP_URI;
    options.destination = destination;
  } else {
    options.type = _constants.CONVERSATION_URL;
    options.destination = conversationServiceUrl + '/' + _constants.CONVERSATIONS + '/' + destination;
  }
  return options;
};

/**
 * Helper function to build up a correct locus url depending on the value passed
 * @param {String} type One of [SIP_URI, PERSONAL_ROOM, MEETING_ID, CONVERSATION_URL, LOCUS_ID, MEETING_LINK]
 * @param {Object} value ?? value.value
 * @returns {Object} returns an object with {resource, method}
 */
MeetingInfoUtil.getResourceUrl = function (type, value) {
  var resource = '/' + _constants.LOCI + '/' + _constants.MEETINGINFO;
  var method = _constants.GET;
  switch (type) {
    case _constants.SIP_URI:
    case _constants.PERSONAL_ROOM:
    case _constants.MEETING_ID:
      resource = '/' + _constants.LOCI + '/' + _constants.MEETINGINFO + '/' + value + '?' + _constants.TYPE + '=' + type + '&' + _constants.USE_URI_LOOKUP_FALSE;
      break;
    case _constants.CONVERSATION_URL:
      method = _constants.PUT;
      break;
    case _constants.LOCUS_ID:
      resource = '/' + _constants.LOCI + '/' + value + '/' + _constants.MEETINGINFO;
      method = _constants.PUT;
      break;
    case _constants.MEETING_LINK:
      resource = '$/' + _constants.LOCI + '/' + _constants.MEETINGINFO + '/' + (0, _btoa2.default)(value) + '?' + _constants.TYPE + '=' + _constants.MEETING_LINK + '&' + _constants.USE_URI_LOOKUP_FALSE;
      break;
    default:
  }
  return {
    resource: resource,
    method: method
  };
};

MeetingInfoUtil.getRequestParams = function (resourceOptions, type, value, api) {
  var requestParams = {
    method: resourceOptions.method,
    api: api,
    resource: resourceOptions.resource
  };
  if (resourceOptions.method === _constants.GET) {
    // for handling URL redirections
    requestParams.resource = requestParams.resource.concat('&' + _constants.ALTERNATE_REDIRECT_TRUE);
  } else if (type !== _constants.LOCUS_ID) {
    // locus id check is a PUT not sure why
    requestParams.body = {
      value: value,
      lookupType: type,
      alternateRedirect: true
    };
  }
  return requestParams;
};

MeetingInfoUtil.getMeetingInfoAPIFormat = function (options) {
  return {
    type: options.type,
    value: options.destination
  };
};

exports.default = MeetingInfoUtil;
//# sourceMappingURL=util.js.map
